module.exports = __webpack_public_path__ + "static/media/scape-admin-edit-icon.670292d5.svg";